<template>
    <div class="d-flex flex-column" id="history">
        <v-row ref="headerFilters">
            <data-table-filters v-if="!isMobile"
                :name="$t('orders.history.title')"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :hasActiveFilters="hasActiveFilters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
            >
            </data-table-filters>
            <div v-else  class="col wrap-title-filters">
             <filters-dialog
                 :name="$t('orders.history.title')"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :hasActiveFilters="hasActiveFilters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
              >
             </filters-dialog>
        </div>
        </v-row>

        <v-row>
            <v-col cols="12">
                <pure-datatable endpoint="/api/orders/history" :queryParams="queryParams" :ready="ready" ref="datatable" @data-changed="dataChanged" v-slot:default="{ vOn, vBind, updateOptions, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="order_history"
                            class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :headers="tHeaders(headers)"
                            :header-props="headerProps"
                            :hide-default-headers="isMobile"
                            :class="{mobile: isMobile}"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            item-key="document_id"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions:itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                        >
                            <template v-if="!isMobile" #[`item.created_at`]="scope">
                                <div class="d-flex justify-center align-center">
                                    <div style="cursor: pointer" @click="openOrderDetails(scope.item)">
                                        {{ scope.item.created_at | moment }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.document_id`]="scope">
                                <div class="d-flex justify-start align-center">
                                    <div style="cursor: pointer" @click="openOrderDetails(scope.item)">
                                        {{ scope.item.document_id }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.branch__name`]="scope">
                                <div class="d-flex justify-start align-center">
                                    <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(scope.item)">
                                        {{ branchName(scope.item) }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.tracking_number`]="scope">
                                <div class="d-flex justify-start align-center">
                                    <div style="cursor: pointer" @click="openOrderDetails(scope.item)">
                                        {{ scope.item.tracking_number }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.total_net_value`]="scope">
                                <div class="d-flex justify-start align-center">
                                    <div style="cursor: pointer" @click="openOrderDetails(scope.item)">
                                        {{ formatPrice(scope.item.total_net_value) }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.status`]="scope">
                                <div class="d-flex justify-start align-center">
                                    <span style="cursor: pointer" @click="openOrderDetails(scope.item)" :style="scope.item.status === 'PROCESSADO' ? 'color: green' : 'color: red'">{{ tb(scope.item.status) }}</span>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.actions`]="scope">
                                <div class="d-flex justify-end align-center">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openOrderDetails(scope.item)"> mdi-dots-horizontal-circle-outline </v-icon>
                                        </template>
                                        <span>{{ $t('orders.orderDetails') }}</span>
                                    </v-tooltip>
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                                <tr>
                                    <v-card
                                    elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('table.status') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('table.client') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('table.date') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('table.document') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" style="min-height: 35px;" v-if="item.invoice_number!=null">{{ $t('table.generatedInvoices') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="item.tracking_number!=null" >{{ $t('table.trackingNumber') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('table.total') }}</v-col>
                                                </v-col>
                                                <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0">
                                                        <v-col class="d-flex px-0 mx-0 pt-0 pb-0 flex-column">
                                                            <v-col class="d-flex align-start px-0 pt-0 pb-0">
                                                                <v-col class="col col-11 px-0 pt-0 pb-0 field-r ">
                                                                    <span style="cursor: pointer" @click="openOrderDetails(item)" :style="item.status === 'PROCESSADO' ? 'color: green' : 'color: red'">{{ tb(item.status) }}</span>
                                                                </v-col>
                                                                <v-col class="col col-1 px-0 pt-0 pb-0">
                                                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openOrderDetails(item)"> mdi-dots-horizontal-circle-outline </v-icon>
                                                                </v-col>
                                                            </v-col>
                                                        </v-col>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(item)">
                                                            {{ branchId(item) }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(item)">
                                                            {{ item.created_at | moment }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(item)">
                                                            {{ item.document_id }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" style="min-height: 32px;" v-if="item.invoice_number!=null">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(item)">
                                                            {{ item.invoice_number }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.tracking_number!=null">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(item)">
                                                            {{ item.tracking_number}}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="openOrderDetails(item)">
                                                            {{ formatPrice(item.total_net_value) }}
                                                        </div>
                                                    </v-col>

                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    </v-card>
                                </tr>
                            </template>
                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="canExport()" :scope="scope" @export="exportData" @updateOptions="updateOptions" :showOrderButton="false" :isLoading="isLoading"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>

        <order-details-dialog v-if="isOrderDetailsDialogOpen" :value="isOrderDetailsDialogOpen" @onCancel="isOrderDetailsDialogOpen = false" :selectedOrder="selectedOrder" :detailsHeaders="details_headers"> </order-details-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import {useAppStore} from '@/Stores/app'
import PureDatatable from '@arentia/atools/PureDatatable';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import moment from 'moment';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],

        // Receiving the table data for order details here aswell
        details_headers: [Object, Array],
    },

    data: () => ({
        datatableSize: 200,
        resizeObserver: null,

        filters: {},
        queryParams: {},
        ready: false,
        hasExpandedActiveFilters: false,

        minEndDate: null,

        selectedOrder: {},
        isOrderDetailsDialogOpen: false,
        itemsPerPageOptions: window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[20,40,50]
    }),

    filters: {
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
    },

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;

                this.ready = true;
                this.refresh();
            },
            immediate: true,
        },
    },

    created() {
        this.applyDefaultFilters();
    },

    mounted() {
        this.prepareResponsiveBehaviour();
        this.refresh();
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
                 this.refreshDeely()

        })
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        setItemsPorPage(){
            this.itemsPerPageOptions=window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[10,20,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        dataChanged() {
            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        branchName(item) {
            return this.userStore.hasPermissionTo('View client and branch number') ? item.branch.name + ' (' + item.branch.id + ')' : item.branch.name;
        },
        branchId(item) {
            return this.userStore.hasPermissionTo('View client and branch number') ? item.branch.id : item.branch.name;
        },
        canExport() {
            return this.userStore.hasPermissionTo('Export order history');
        },

        exportData() {
            if (!this.branchStore.branch || !this.$refs.datatable) return;

            const axiosSettings = {
                url: '/api/orders/history/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable.exportData(axiosSettings, 'export_historico_encomendas');
        },

        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);

            this.onFiltersChanged();
        },
        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh();
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },
        setFieldsDisabledStateTo(bool) {
            for (const key in this.schema) {
                this.schema[key].disabled = bool;
            }
        },

        refresh(options) {
            if (!this.branchStore.branch) return;

            // Check if the created_at_start and created_at_end filters are valid (must be within a 1 year interval, will use created_at_start as the basis for all checks)
            if (this.filters.created_at_start != null) {
                // Set the limit end date to 1 year starting from the created_at_start
                this.minEndDate = this.filters.created_at_start;
                this.schema.created_at_end.minDate = this.minEndDate;

                // If the other date is set and somehow exceeds the 1 year maximum gap, we'll adjust it accordingly
                if (this.filters.created_at_end) {
                    // if end date is set and is lower than start date, set a new end date 1 year from the start date
                    const minEndDate = moment(this.filters.created_at_start).format('YYYY-MM-DD');
                    if (moment(this.filters.created_at_end) < moment(minEndDate)) this.filters.created_at_end = null;
                }
            } else {
                // Clear the limit end date
                this.minEndDate = null;
                this.schema.created_at_end.minDate = null;
            }

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                    options=this.$refs.datatable.localOptions
                    options.itemsPerPage=window.innerWidth>=768&&window.innerWidth<=1366?20:20
                    this.$refs.datatable.setLocalOptions(options);
                }
                this.$refs.datatable.onChangeQueryBuilder(this.filters, this.schema);
            }
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        clearNormalFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            // Enable the basic filters if the advanced filters are not active.
            this.setFieldsDisabledStateTo(false);

            this.refresh();
        },

        onClearFilters() {
            this.clearNormalFilters();
        },

        changeOrder(newOrder) {
            this.selectedOrder = newOrder;
        },

        openOrderDetails(order) {
            this.selectedOrder = order;
            this.isOrderDetailsDialogOpen = true;
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>
